import { paramDestDs, paramDestPath, paramSourceDs, paramSourcePath } from "../constants/parameterNames";
import { typeDataSource, typeXPath } from '../constants/parameterTypes';

import { executeAsync, LOCATION_PARAMETER } from "./copyMoveBase";

const optionalParameters = [
    {
        name: paramSourceDs,
        description: "The name of the data source from which the node should be copied",
        type: typeDataSource
    },
    {
        name: paramDestDs,
        description: "The name of the data source to which the node should be copied",
        type: typeDataSource
    },
    LOCATION_PARAMETER,
];

const requiredParameters = [
    {
        name: paramSourcePath,
        description: "The xpath of the node to copy",
        type: typeXPath,
        dsParentName: paramSourceDs
    },
    {
        name: paramDestPath,
        description: "The XPath of the location where the node should be copied",
        type: typeXPath,
        dsParentName: paramDestDs
    },
];

const description = "Copies xml nodes to a new destination.";

const Copy = {
    description,
    optionalParameters,
    requiredParameters,
    executeAsync: executeAsync(false),
};

export default Copy;